import Artwork from "./Artwork";
import { Reveal, Eyebrow } from "./Reveal";
import { CONTENT } from "@/content";

export default function About() {
  return (
    <section id="about" data-testid="about-section" className="relative py-28 md:py-44 px-6 md:px-16 max-w-[1600px] mx-auto">
      <div className="grid lg:grid-cols-2 gap-12 lg:gap-20 items-start">
        <div>
          <Reveal>
            <Eyebrow>ABOUT TONE</Eyebrow>
          </Reveal>
          <div className="mt-8 space-y-1">
            {CONTENT.aboutLines.map((line, i) => (
              <Reveal key={line} delay={0.08 * i}>
                <p
                  className={`font-display font-extrabold uppercase tracking-tight leading-[0.95] text-[7.7vw] sm:text-5xl lg:text-4xl xl:text-5xl 2xl:text-6xl ${
                    i === 1 ? "text-[#70c7fa]" : "text-[#f5f3ef]"
                  }`}
                >
                  {line}
                </p>
              </Reveal>
            ))}
          </div>
          <Reveal delay={0.3}>
            <p data-testid="about-bio" className="mt-10 text-sm md:text-base text-[#a3a3ac] font-light leading-relaxed max-w-md">
              {CONTENT.aboutBio}
            </p>
          </Reveal>
        </div>

        <Reveal delay={0.15} className="lg:mt-16">
          <div data-testid="about-portrait" className="relative">
            <Artwork variant="veil" image={CONTENT.aboutImage} alt="TONE — Artist Portrait" breathe className="w-full aspect-[3/4]" />
            <div className="absolute top-0 -left-px w-px h-24 bg-gradient-to-b from-[#38bdf8]/70 to-transparent" />
          </div>
        </Reveal>
      </div>

      <div data-testid="about-statement" className="mt-24 lg:mt-36 border-t border-white/10 pt-14 lg:pt-20 grid lg:grid-cols-2 gap-10 lg:gap-20 items-end">
        <Reveal>
          <p className="font-display font-extrabold uppercase tracking-tight leading-[1.05] text-2xl sm:text-3xl lg:text-4xl text-[#f5f3ef]">
            „{CONTENT.aboutStatement.line}"
          </p>
        </Reveal>
        <Reveal delay={0.15}>
          <p className="text-sm md:text-base text-[#a3a3ac] font-light leading-relaxed">{CONTENT.aboutStatement.text}</p>
          <a
            data-testid="about-epk-link"
            href={CONTENT.epkUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="mt-8 inline-flex items-center gap-2 px-8 py-3.5 border border-white/15 font-mono2 text-[11px] tracking-[0.3em] text-[#f5f3ef] hover:border-[#38bdf8]/70 hover:text-[#70c7fa] hover:shadow-[0_0_28px_rgba(56,189,248,0.18)] transition-all duration-500"
          >
            EPK — PRESS KIT ↗
          </a>
        </Reveal>
      </div>
    </section>
  );
}
